"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _assets = require("@mulesoft/exchange-ui-portals-store/lib/domains/assets");
var _EditableLabels = _interopRequireDefault(require("./EditableLabels"));
var EVENT_TYPES = {
  TAGS_UPDATED: 'Tags updated',
  NEW_TAG_CLICKED: 'New tag clicked',
  TAG_CREATION_CANCELED: 'Tag creation canceled'
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var trackEvent = _ref.trackEvent;
  return {
    onUpdateLabels: function onUpdateLabels(payload) {
      return dispatch(_assets.actions.updateLabels(payload));
    },
    onNewLabelClick: function onNewLabelClick() {
      return trackEvent(EVENT_TYPES.NEW_TAG_CLICKED);
    },
    onLeaveCreatingState: function onLeaveCreatingState() {
      return trackEvent(EVENT_TYPES.TAG_CREATION_CANCELED);
    }
  };
};
var _default = exports.default = (0, _redux.compose)(_exchangeReactHooks.withRouter, _exchangeReactHooks.withAnalytics, (0, _reactRedux.connect)(null, mapDispatchToProps))(_EditableLabels.default);
//# sourceMappingURL=EditableLabels.container.js.map